import {
    FaTiktok,
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
} from 'react-icons/fa'

export default function SocialButtons() {
    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-5">

            <a
                href="https://wa.me/50239990332"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:scale-110 transition"
            >
                <FaWhatsapp size={32} />
            </a>
            <a
                href="https://www.tiktok.com/@despega.gt?_r=1&_t=ZS-93hurkr3J8D"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:scale-110 transition"
            >
                <FaTiktok size={32} />
            </a>

            <a
                href="https://www.facebook.com/despegagt"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:scale-110 transition"
            >
                <FaFacebook size={32} />
            </a>

            <a
                href="https://www.instagram.com/despegagt?igsh=MWJ4bmR0eHd2bDdybg=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:scale-110 transition"
            >
                <FaInstagram size={32} />
            </a>
        </div>
    )
}